import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { AppService } from "../service/AppService.class";
import { environment } from "../../../environments/environment";

@Injectable()
export class MenuService extends AppService<any>{
  constructor(protected http: HttpClient) {
    super(http);
    this.appmod = "getcdr";
  }

  getDetails(data?:any): Observable<any>{ 
    // return this.http.get('../../assets/details.json')

    this.appmod = "custom/details";
    return this.http.get<any>(environment.SERVER + this.appmod,{ headers: { "Content-Type": "application/json" }, params: { type: data } });
  }

  // public getMenu():Observable<any>{
  //   return this.http.get('/assets/menu.json');
  // }

  public getAdminMenu(): Observable<any> {
    return this.http.get('/assets/adminmenu.json');
  }

  public getCustomerMenu(): Observable<any> {
    return this.http.get('/assets/customermenu.json');
  }

  public getAboutCustomerMenuServices():Observable<any>
  {
    return this.http.get('/assets/jsondata/reports.json');
  }

}
